import { render, staticRenderFns } from "./TreeChildrenSelect.vue?vue&type=template&id=5c859a3b"
import script from "./TreeChildrenSelect.vue?vue&type=script&lang=js"
export * from "./TreeChildrenSelect.vue?vue&type=script&lang=js"
import style0 from "./TreeChildrenSelect.vue?vue&type=style&index=0&id=5c859a3b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports